export default __webpack_public_path__ + "static/media/ceo-profile.87d5242b.png";